import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';

const getElementDelay = (element, defaultDelay) => {
  const delay = Number.parseFloat(element.dataset.revealDelay);

  return Number.isFinite(delay) ? delay : defaultDelay;
};

const initSplitTitle = ({
  selector = '.js-reveal-title',
  start = 'top 80%',
  duration = 0.9,
  stagger = 0.15,
  delay = 0.7,
} = {}) => {
  gsap.registerPlugin(ScrollTrigger, SplitText);

  const elements = gsap.utils.toArray(selector);

  elements.forEach((element) => {
    SplitText.create(element, {
      type: 'lines',
      mask: 'lines',
      autoSplit: true,

      onSplit(self) {
        return gsap.from(self.lines, {
          yPercent: 110,
          opacity: 0,
          duration,
          delay: getElementDelay(element, delay),
          stagger,
          ease: 'power4.out',

          scrollTrigger: {
            trigger: element,
            start,
            once: true,
          },
        });
      },
    });
  });

  ScrollTrigger.refresh();
};

export default initSplitTitle;
